import { Flex, styled } from '@withjoy/joykit';

export const DashboardRoot = styled(Flex)<{ isBannerVisible: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  margin-top: 0px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm2}) {
    max-height: 100%;
  }
`;

export const ContentWrapper = styled(Flex)`
  display: flex;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    display: flex;
    flex-direction: row;
  }
`;

export const SidebarRoot = styled.aside`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    display: block;
    width: 45%;
  }
`;

export const NavigationRoot = styled.main`
  border-right: solid 0.0625rem ${({ theme }) => theme.colors.mono4};
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100vw;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    overflow: visible;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    width: 55%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md3}) {
    width: 67%;
  }
`;
